var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSpeaking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1068",
    "data-name": "Rectangle 1068",
    width: 29.849,
    height: 32.386,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_speaking",
    transform: "translate(-328.833 -215.421)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(328.833 215.421)",
    fill: "rgba(195,230,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202",
    transform: "translate(338.908 224.228)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21813",
    "data-name": "Path 21813",
    d: "M8.319,2.635,4.959,6.56l-1.07,5.13L1.055,15.707.245,16.877l2.111.423.156,6.491,4.932.375L9.9,26.033l.4,5.139H22.219v-5.2l.291-2.692,1.808-2.18,2.626-3.322L28.632,13.8V8.557L27.3,5.124,24.638,2.4,21.5.965,14.439.243Z",
    transform: "translate(0.491 0.485)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_202-2",
    "data-name": "Group 202",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21814",
    "data-name": "Path 21814",
    d: "M17.33,19.189H14.392V12.2a2.759,2.759,0,0,0-.8-2.2,4.735,4.735,0,0,0-3.1-.824H.924V6.24h9.564a7.36,7.36,0,0,1,5.034,1.553,5.573,5.573,0,0,1,1.808,4.416Z",
    transform: "translate(1.846 12.467)",
    fill: "#d84f45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21815",
    "data-name": "Path 21815",
    d: "M22.709,32.386H10.791a.727.727,0,0,1-.729-.741C10.1,29.04,9.745,26.983,9.07,26c-.585-.854-3.949-1.1-6.032-1a.7.7,0,0,1-.759-.687l-.231-4.023v-.036a.571.571,0,0,1,0-.1L2.1,18.447c-.4-.036-.9-.072-1.274-.072A.8.8,0,0,1,.1,17.947c-.285-.543.033-1,.977-2.357,1.04-1.5,2.779-4,2.821-5.756C3.98,6.527,8.078.237,15.627.012c4.95-.144,8.886,1.034,11.348,3.424a9.7,9.7,0,0,1,2.878,7.151c0,5.118-2.258,7.924-4.068,10.179-1.31,1.634-2.348,2.923-2.348,4.68v6.212a.729.729,0,0,1-.729.729m-5-1.457H21.98V25.445c0-2.27,1.3-3.886,2.668-5.595,1.757-2.183,3.745-4.659,3.745-9.264a8.279,8.279,0,0,0-2.431-6.1c-2.174-2.108-5.738-3.148-10.293-3.013C9.124,1.664,5.422,7.12,5.356,9.87c-.054,2.2-1.874,4.818-3.079,6.554-.126.174-.255.363-.375.543.537.042,1,.093,1.028.1a.732.732,0,0,1,.648.747L3.5,20.174l0,.036.189,3.313c1.751-.033,5.523.1,6.584,1.652.965,1.412,1.223,3.784,1.241,5.753Z",
    transform: "translate(-0.001 -0.001)",
    fill: "#404040"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSpeaking);
export default __webpack_public_path__ + "static/media/ic_speaking.432148669535e9b791d33241141002dc.svg";
export { ForwardRef as ReactComponent };